import { SpaOutlined } from "@mui/icons-material";
import { Modal } from "@mui/material";
import { useState } from "react";
import { ImCross } from "react-icons/im";
import { selectSite } from "../../utils/helper/commonSelectors";
import { useSelector } from "react-redux";

const FancyBook = ({ fancyBook }) => {
  const [open, setOpen] = useState(false);
  const topHeaderColor = useSelector(selectSite())?.headerColor;

  const handleClose = () => {
    setOpen(false);
  };  

  const backBets = fancyBook?.currentOddsBetDataOfThisMarket?.filter(
    (item) => item.type === "Back"
  );
  const layBets = fancyBook?.currentOddsBetDataOfThisMarket?.filter(
    (item) => item.type === "Lay"
  );

  const filteredBets = [...layBets, ...backBets];
  const prices = filteredBets.map((item) => item.price);
  const minPrice = Math.min(...prices) - 1;
  const maxPrice = Math.max(...prices) + 1;
  const priceRange = Array.from(
    { length: maxPrice - minPrice + 1 },
    (_, i) => minPrice + i
  );

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        disabled={fancyBook?.currentOddsBetDataOfThisMarket <= 0}
        style={{ textAlign: "left" }}
      >
        {fancyBook.marketRunnerName}
      </button>
      <Modal open={open}>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{marginTop:"-250px"}}>
          <div className="bg-white rounded-[10px] shadow-lg w-full max-w-md">
            <div
              className="bg-gradient-to-r text-white px-4 py-0.5 rounded-t-md flex justify-between items-center"
              style={{
                backgroundImage: `linear-gradient(180deg, ${topHeaderColor?.start}, ${topHeaderColor?.end})`,
              }}
            >
              <h2 className="text-md font-medium">Exposure</h2>
              <button
                onClick={() => {
                  handleClose();
                }}
                className="text-white text-2xl font-light"
              >
                ×
              </button>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                padding: 4,
              }}
            ></div>
            <div className="w-full">
              <div className="px-3">
                <div className="p-1 text-xs">
                  <h3 className="text-xs font-semibold mb-2">
                    {fancyBook?.marketRunnerName}
                  </h3>
                </div>
              </div>

              <div className="border border-gray-300 rounded-sm overflow-hidden space-y-0.5">
                {priceRange.map((price, index) => {
                  const winningBets = filteredBets?.filter((bet) => {
                    if (
                      (bet.type === "Lay" && price < bet.price) ||
                      (bet.type === "Back" && price >= bet.price)
                    ) {
                      return true;
                    } else {
                      return false;
                    }
                  });
                  const losingBets = filteredBets?.filter((bet) => {
                    if (
                      (bet.type === "Lay" && price < bet.price) ||
                      (bet.type === "Back" && price >= bet.price)
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  });

                  const winningAmount = winningBets?.reduce(
                    (sum, item) => sum + item.favourMargin,
                    0
                  );
                  const losingAmount = losingBets?.reduce(
                    (sum, item) => sum + item.againstMargin,
                    0
                  );
                  const finalAmount = winningAmount - losingAmount;

                  return (
                    <div
                      className="flex w-full px-3"
                      style={{ fontSize: 11, fontWeight: "bold", marginBottom:"-2px" }}
                    >
                      <div
                        className="w-[50%] p-2 border border-[white]"
                        style={{
                          backgroundColor:
                            finalAmount < 0 ? "#FAA9BA" : "#72BBEF",
                        }}
                      >
                        {price}
                      </div>

                      <div
                        className="w-[50%] border border-[white] p-2 text-end"
                        style={{
                          color: finalAmount < 0 ? "red" : "green",
                          backgroundColor:
                            finalAmount < 0 ? "#FAA9BA" : "#72BBEF",
                        }}
                      >
                        {finalAmount}
                      </div>
                    </div>
                  );
                })}

                <div className="w-full flex justify-center py-3">
                  <button
                    onClick={() => {
                      handleClose();
                    }}
                    className="text-[red] rounded text-[13px] border border-[red] py-1.5 px-4"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default FancyBook;
